import { PayloadAction } from '@reduxjs/toolkit';

import { VariantsState } from 'editor/src/store/variants/types';

const setSelectedDesignOptionReducer = (state: VariantsState, action: PayloadAction<string | undefined>) => {
  state.selectedDesignOptionValue = action.payload;
};

export default setSelectedDesignOptionReducer;
